// i18n key constants — all values equal their key name so t(S.KEY) looks up the
// correct translation in the active locale JSON file.
// Actual translations live in de.json / en.json / fr.json.
export const S = {
  // Navigation / Menus
  DECK_SELECTOR_TITLE: 'DECK_SELECTOR_TITLE',
  MAP_SELECT_TITLE: 'MAP_SELECT_TITLE',
  MAP_SELECT_BACK: 'MAP_SELECT_BACK',
  MAP_SELECT_DESC_VULKAN: 'MAP_SELECT_DESC_VULKAN',
  MAP_SELECT_DESC_KUESTENFORT: 'MAP_SELECT_DESC_KUESTENFORT',
  MAP_SELECT_DESC_RUINEN: 'MAP_SELECT_DESC_RUINEN',
  MAP_SELECT_DESC_EISOEDE: 'MAP_SELECT_DESC_EISOEDE',
  MAP_SELECT_DESC_WUESTE: 'MAP_SELECT_DESC_WUESTE',
  MAP_SELECT_DESC_DSCHUNGEL: 'MAP_SELECT_DESC_DSCHUNGEL',
  MAP_SELECT_DESC_HOCHGEBIRGE: 'MAP_SELECT_DESC_HOCHGEBIRGE',
  MAP_SELECT_DESC_SUMPF: 'MAP_SELECT_DESC_SUMPF',

  // DeckBuilder tabs
  DECKBUILDER_TAB_TOWERS: 'DECKBUILDER_TAB_TOWERS',
  DECKBUILDER_TAB_UNITS: 'DECKBUILDER_TAB_UNITS',
  DECKBUILDER_TAB_HERO: 'DECKBUILDER_TAB_HERO',

  // Chat overlay
  CHAT_PLACEHOLDER: 'CHAT_PLACEHOLDER',
  CHAT_SEND: 'CHAT_SEND',
  CHAT_TOGGLE: 'CHAT_TOGGLE',
  CHAT_NO_MESSAGES: 'CHAT_NO_MESSAGES',
  CHAT_QUICK_PHRASE_GG: 'CHAT_QUICK_PHRASE_GG',
  CHAT_RATE_LIMIT: 'CHAT_RATE_LIMIT',

  // HUD
  HUD_CLOSE: 'HUD_CLOSE',
  HUD_SURRENDER: 'HUD_SURRENDER',
  HUD_SURRENDER_CONFIRM: 'HUD_SURRENDER_CONFIRM',
  HUD_WAVE: 'HUD_WAVE',
  HUD_DAILY_QUESTS: 'HUD_DAILY_QUESTS',
  HUD_NO_ACTIVE_QUESTS: 'HUD_NO_ACTIVE_QUESTS',
  HUD_SPELL_READY: 'HUD_SPELL_READY',
  HUD_SPY_LABEL: 'HUD_SPY_LABEL',
  HUD_UPGRADE: 'HUD_UPGRADE',
  HUD_MAX_LEVEL: 'HUD_MAX_LEVEL',
  HUD_DEMOLISH: 'HUD_DEMOLISH',
  HUD_CHOOSE_PATH: 'HUD_CHOOSE_PATH',
  HUD_MUSIC_ON: 'HUD_MUSIC_ON',
  HUD_MUSIC_OFF: 'HUD_MUSIC_OFF',

  // MatchResult
  MATCH_RESULT_NO_STATS: 'MATCH_RESULT_NO_STATS',
  MATCH_RESULT_VICTORY: 'MATCH_RESULT_VICTORY',
  MATCH_RESULT_DEFEAT: 'MATCH_RESULT_DEFEAT',
  MATCH_RESULT_DRAW: 'MATCH_RESULT_DRAW',
  MATCH_RESULT_WINNER: 'MATCH_RESULT_WINNER',
  MATCH_RESULT_TOTAL_DAMAGE: 'MATCH_RESULT_TOTAL_DAMAGE',
  MATCH_RESULT_GOLD_EARNED: 'MATCH_RESULT_GOLD_EARNED',
  MATCH_RESULT_UNITS_SENT: 'MATCH_RESULT_UNITS_SENT',
  MATCH_RESULT_TOWERS_BUILT: 'MATCH_RESULT_TOWERS_BUILT',
  MATCH_RESULT_DURATION: 'MATCH_RESULT_DURATION',
  MATCH_RESULT_PLAY_AGAIN: 'MATCH_RESULT_PLAY_AGAIN',
  MATCH_RESULT_MAIN_MENU: 'MATCH_RESULT_MAIN_MENU',
  MATCH_RESULT_PLAYER: 'MATCH_RESULT_PLAYER',
  MATCH_RESULT_OPPONENT: 'MATCH_RESULT_OPPONENT',
  MATCH_RESULT_TOWER_DAMAGE: 'MATCH_RESULT_TOWER_DAMAGE',
  MATCH_RESULT_UNITS_BREAKDOWN: 'MATCH_RESULT_UNITS_BREAKDOWN',
  CAMPAIGN_HUD_OBJECTIVE: 'CAMPAIGN_HUD_OBJECTIVE',

  // Shop
  SHOP_TITLE: 'SHOP_TITLE',
  SHOP_GOLD_LABEL: 'SHOP_GOLD_LABEL',
  SHOP_GEMS_COMING_SOON: 'SHOP_GEMS_COMING_SOON',
  SHOP_SEASON_COMING_SOON: 'SHOP_SEASON_COMING_SOON',
  SHOP_TAB_PACKS: 'SHOP_TAB_PACKS',
  SHOP_TAB_GEMS: 'SHOP_TAB_GEMS',
  SHOP_TAB_SEASON: 'SHOP_TAB_SEASON',
  SHOP_BUY: 'SHOP_BUY',
  SHOP_NOT_ENOUGH_GOLD: 'SHOP_NOT_ENOUGH_GOLD',
  SHOP_GEMS_LABEL: 'SHOP_GEMS_LABEL',
  SHOP_COMING_SOON_BADGE: 'SHOP_COMING_SOON_BADGE',
  SHOP_SUBSCRIBE: 'SHOP_SUBSCRIBE',
  SHOP_DURATION_DAYS: 'SHOP_DURATION_DAYS',

  // Quest Widget (MainMenu)
  QUEST_WIDGET_TITLE: 'QUEST_WIDGET_TITLE',
  QUEST_WIDGET_ALL_LINK: 'QUEST_WIDGET_ALL_LINK',

  // MainMenu
  MAIN_MENU_TITLE: 'MAIN_MENU_TITLE',
  MAIN_MENU_PLAY_PVP: 'MAIN_MENU_PLAY_PVP',
  MAIN_MENU_PLAY: 'MAIN_MENU_PLAY',
  MAIN_MENU_DECK_BUILDER: 'MAIN_MENU_DECK_BUILDER',
  MAIN_MENU_MY_DECKS: 'MAIN_MENU_MY_DECKS',
  MAIN_MENU_SHOP: 'MAIN_MENU_SHOP',
  MAIN_MENU_INVENTORY: 'MAIN_MENU_INVENTORY',
  MAIN_MENU_PROFILE: 'MAIN_MENU_PROFILE',
  MAIN_MENU_SETTINGS: 'MAIN_MENU_SETTINGS',
  MAIN_MENU_LOGIN_REGISTER: 'MAIN_MENU_LOGIN_REGISTER',
  MAIN_MENU_LOGOUT: 'MAIN_MENU_LOGOUT',

  // Inventory Screen
  INVENTORY_TITLE: 'INVENTORY_TITLE',
  INVENTORY_BACK: 'INVENTORY_BACK',
  INVENTORY_EMPTY: 'INVENTORY_EMPTY',
  INVENTORY_EMPTY_SHOP_LINK: 'INVENTORY_EMPTY_SHOP_LINK',
  INVENTORY_OPEN_BTN: 'INVENTORY_OPEN_BTN',
  INVENTORY_PACKS_SECTION: 'INVENTORY_PACKS_SECTION',
  INVENTORY_TAB_PACKS: 'INVENTORY_TAB_PACKS',
  INVENTORY_TAB_CARDS: 'INVENTORY_TAB_CARDS',
  INVENTORY_CARDS_EMPTY: 'INVENTORY_CARDS_EMPTY',
  INVENTORY_CARD_COPIES: 'INVENTORY_CARD_COPIES',

  // Settings screen
  SETTINGS_TITLE: 'SETTINGS_TITLE',
  SETTINGS_LANGUAGE: 'SETTINGS_LANGUAGE',
  SETTINGS_BACK: 'SETTINGS_BACK',
  SETTINGS_SOUND: 'SETTINGS_SOUND',

  // Login screen
  LOGIN_TITLE: 'LOGIN_TITLE',
  LOGIN_EMAIL: 'LOGIN_EMAIL',
  LOGIN_PASSWORD: 'LOGIN_PASSWORD',
  LOGIN_SUBMIT: 'LOGIN_SUBMIT',
  LOGIN_REGISTER_LINK: 'LOGIN_REGISTER_LINK',
  LOGIN_GUEST: 'LOGIN_GUEST',
  LOGIN_FORGOT_PASSWORD: 'LOGIN_FORGOT_PASSWORD',
  LOGIN_RESET_SEND: 'LOGIN_RESET_SEND',
  LOGIN_RESET_SENT: 'LOGIN_RESET_SENT',
  LOGIN_BACK_TO_LOGIN: 'LOGIN_BACK_TO_LOGIN',

  // Register screen
  REGISTER_TITLE: 'REGISTER_TITLE',
  REGISTER_DISPLAYNAME: 'REGISTER_DISPLAYNAME',
  REGISTER_SUBMIT: 'REGISTER_SUBMIT',
  REGISTER_LOGIN_LINK: 'REGISTER_LOGIN_LINK',
  REGISTER_CONFIRM_PASSWORD: 'REGISTER_CONFIRM_PASSWORD',
  REGISTER_PASSWORD_TOO_SHORT: 'REGISTER_PASSWORD_TOO_SHORT',
  REGISTER_PASSWORDS_MISMATCH: 'REGISTER_PASSWORDS_MISMATCH',

  // Leaderboard screen
  LEADERBOARD_TITLE: 'LEADERBOARD_TITLE',
  LEADERBOARD_GLOBAL: 'LEADERBOARD_GLOBAL',
  LEADERBOARD_NATIONAL: 'LEADERBOARD_NATIONAL',
  LEADERBOARD_LOADING: 'LEADERBOARD_LOADING',
  LEADERBOARD_BACK: 'LEADERBOARD_BACK',
  LEADERBOARD_MY_POSITION: 'LEADERBOARD_MY_POSITION',
  LEADERBOARD_TOTAL_PLAYERS: 'LEADERBOARD_TOTAL_PLAYERS',
  LEADERBOARD_MONTH_LABEL: 'LEADERBOARD_MONTH_LABEL',
  LEADERBOARD_EMPTY: 'LEADERBOARD_EMPTY',
  LEADERBOARD_COL_RANK: 'LEADERBOARD_COL_RANK',
  LEADERBOARD_COL_NAME: 'LEADERBOARD_COL_NAME',
  LEADERBOARD_COL_COUNTRY: 'LEADERBOARD_COL_COUNTRY',
  LEADERBOARD_COL_POINTS: 'LEADERBOARD_COL_POINTS',
  LEADERBOARD_COL_LEAGUE: 'LEADERBOARD_COL_LEAGUE',
  // Leaderboard screen (Global + Friends tabs)
  LEADERBOARD_TAB_GLOBAL: 'LEADERBOARD_TAB_GLOBAL',
  LEADERBOARD_TAB_FRIENDS: 'LEADERBOARD_TAB_FRIENDS',
  LEADERBOARD_RANK: 'LEADERBOARD_RANK',
  LEADERBOARD_PLAYER: 'LEADERBOARD_PLAYER',
  LEADERBOARD_RECORD: 'LEADERBOARD_RECORD',
  LEADERBOARD_POINTS: 'LEADERBOARD_POINTS',
  LEADERBOARD_LOGIN_PROMPT: 'LEADERBOARD_LOGIN_PROMPT',
  LEADERBOARD_YOU: 'LEADERBOARD_YOU',

  // Auth screen (unified AuthScreen component)
  AUTH_LOGIN_TITLE: 'AUTH_LOGIN_TITLE',
  AUTH_REGISTER_TITLE: 'AUTH_REGISTER_TITLE',
  AUTH_FORGOT_TITLE: 'AUTH_FORGOT_TITLE',
  AUTH_EMAIL: 'AUTH_EMAIL',
  AUTH_USERNAME: 'AUTH_USERNAME',
  AUTH_PASSWORD: 'AUTH_PASSWORD',
  AUTH_CONFIRM_PASSWORD: 'AUTH_CONFIRM_PASSWORD',
  AUTH_LOGIN_BTN: 'AUTH_LOGIN_BTN',
  AUTH_REGISTER_BTN: 'AUTH_REGISTER_BTN',
  AUTH_FORGOT_BTN: 'AUTH_FORGOT_BTN',
  AUTH_GUEST_BTN: 'AUTH_GUEST_BTN',
  AUTH_SWITCH_TO_REGISTER: 'AUTH_SWITCH_TO_REGISTER',
  AUTH_SWITCH_TO_LOGIN: 'AUTH_SWITCH_TO_LOGIN',
  AUTH_SWITCH_TO_FORGOT: 'AUTH_SWITCH_TO_FORGOT',
  AUTH_SWITCH_TO_LOGIN_FROM_FORGOT: 'AUTH_SWITCH_TO_LOGIN_FROM_FORGOT',
  AUTH_FORGOT_SUCCESS: 'AUTH_FORGOT_SUCCESS',
  AUTH_MAIN_MENU_GREETING: 'AUTH_MAIN_MENU_GREETING',
  AUTH_LOGOUT_BTN: 'AUTH_LOGOUT_BTN',
  AUTH_LOGIN_REGISTER_BTN: 'AUTH_LOGIN_REGISTER_BTN',
  AUTH_ERROR_PASSWORDS_MISMATCH: 'AUTH_ERROR_PASSWORDS_MISMATCH',
  AUTH_ERROR_USERNAME_TOO_SHORT: 'AUTH_ERROR_USERNAME_TOO_SHORT',
  AUTH_ERROR_PASSWORD_TOO_SHORT: 'AUTH_ERROR_PASSWORD_TOO_SHORT',

  // Auth errors
  AUTH_ERROR_INVALID_CREDENTIALS: 'AUTH_ERROR_INVALID_CREDENTIALS',
  AUTH_ERROR_EMAIL_TAKEN: 'AUTH_ERROR_EMAIL_TAKEN',
  AUTH_ERROR_NETWORK: 'AUTH_ERROR_NETWORK',

  // Friends panel
  FRIENDS_TAB_LIST: 'FRIENDS_TAB_LIST',
  FRIENDS_TAB_REQUESTS: 'FRIENDS_TAB_REQUESTS',
  FRIENDS_TAB_SEARCH: 'FRIENDS_TAB_SEARCH',
  FRIENDS_LOADING: 'FRIENDS_LOADING',
  FRIENDS_EMPTY: 'FRIENDS_EMPTY',
  FRIENDS_NO_REQUESTS: 'FRIENDS_NO_REQUESTS',
  FRIENDS_CHALLENGE: 'FRIENDS_CHALLENGE',
  FRIENDS_CHALLENGE_SENT: 'FRIENDS_CHALLENGE_SENT',
  FRIENDS_CHALLENGE_OFFLINE: 'FRIENDS_CHALLENGE_OFFLINE',
  FRIENDS_ACCEPT: 'FRIENDS_ACCEPT',
  FRIENDS_DECLINE: 'FRIENDS_DECLINE',
  FRIENDS_REQUEST_ACCEPTED: 'FRIENDS_REQUEST_ACCEPTED',
  FRIENDS_REQUEST_SENT: 'FRIENDS_REQUEST_SENT',
  FRIENDS_REQUEST_ERROR: 'FRIENDS_REQUEST_ERROR',
  FRIENDS_ADD: 'FRIENDS_ADD',
  FRIENDS_ALREADY_FRIENDS: 'FRIENDS_ALREADY_FRIENDS',
  FRIENDS_PENDING: 'FRIENDS_PENDING',
  FRIENDS_SEARCH_PLACEHOLDER: 'FRIENDS_SEARCH_PLACEHOLDER',
  FRIENDS_SEARCHING: 'FRIENDS_SEARCHING',
  FRIENDS_SEARCH_EMPTY: 'FRIENDS_SEARCH_EMPTY',
  FRIENDS_LOGIN_REQUIRED: 'FRIENDS_LOGIN_REQUIRED',

  // Progression Screen
  PROGRESSION_TITLE: 'PROGRESSION_TITLE',
  PROGRESSION_BACK: 'PROGRESSION_BACK',
  PROGRESSION_EXPERIENCE: 'PROGRESSION_EXPERIENCE',
  PROGRESSION_CURRENCY: 'PROGRESSION_CURRENCY',
  PROGRESSION_GOLD: 'PROGRESSION_GOLD',
  PROGRESSION_GEMS: 'PROGRESSION_GEMS',
  PROGRESSION_PACK_PROGRESS: 'PROGRESSION_PACK_PROGRESS',
  PROGRESSION_OPEN_PACK: 'PROGRESSION_OPEN_PACK',
  PROGRESSION_DAILY_QUESTS: 'PROGRESSION_DAILY_QUESTS',
  PROGRESSION_WEEKLY_QUESTS: 'PROGRESSION_WEEKLY_QUESTS',
  PROGRESSION_ACHIEVEMENT_QUESTS: 'PROGRESSION_ACHIEVEMENT_QUESTS',
  PROGRESSION_ACHIEVEMENTS: 'PROGRESSION_ACHIEVEMENTS',
  PROGRESSION_CARD_COLLECTION: 'PROGRESSION_CARD_COLLECTION',
  PROGRESSION_CARDS_COLLECTED: 'PROGRESSION_CARDS_COLLECTED',
  PROGRESSION_DAILY_PACK: 'PROGRESSION_DAILY_PACK',
  PROGRESSION_FRIENDS: 'PROGRESSION_FRIENDS',
  PROGRESSION_CLAIM: 'PROGRESSION_CLAIM',

  // DeckSelector
  DECK_SELECTOR_BACK: 'DECK_SELECTOR_BACK',
  DECK_SELECTOR_NEW_DECK: 'DECK_SELECTOR_NEW_DECK',
  DECK_SELECTOR_SELECTED: 'DECK_SELECTOR_SELECTED',
  DECK_SELECTOR_CARDS: 'DECK_SELECTOR_CARDS',
  DECK_SELECTOR_EDIT: 'DECK_SELECTOR_EDIT',

  // DeckBuilder
  DECK_BUILDER_CANCEL: 'DECK_BUILDER_CANCEL',
  DECK_BUILDER_SAVE: 'DECK_BUILDER_SAVE',
  DECK_BUILDER_NAME_PLACEHOLDER: 'DECK_BUILDER_NAME_PLACEHOLDER',
  DECK_BUILDER_TOTAL_COST: 'DECK_BUILDER_TOTAL_COST',
  DECK_BUILDER_TOWERS_SECTION: 'DECK_BUILDER_TOWERS_SECTION',
  DECK_BUILDER_UNITS_SECTION: 'DECK_BUILDER_UNITS_SECTION',
  DECK_BUILDER_HERO_SECTION: 'DECK_BUILDER_HERO_SECTION',
  DECK_BUILDER_ELEMENTS: 'DECK_BUILDER_ELEMENTS',
  DECK_BUILDER_FILTER_ALL: 'DECK_BUILDER_FILTER_ALL',
  DECK_BUILDER_EMPTY_SLOT: 'DECK_BUILDER_EMPTY_SLOT',
  DECK_BUILDER_NO_TOWERS: 'DECK_BUILDER_NO_TOWERS',
  DECK_BUILDER_NO_UNITS: 'DECK_BUILDER_NO_UNITS',
  DECK_BUILDER_TAB_TOWERS: 'DECK_BUILDER_TAB_TOWERS',
  DECK_BUILDER_TAB_UNITS: 'DECK_BUILDER_TAB_UNITS',
  DECK_BUILDER_TAB_HEROES: 'DECK_BUILDER_TAB_HEROES',
  DECK_BUILDER_CHOOSE_TOWER_SLOT: 'DECK_BUILDER_CHOOSE_TOWER_SLOT',
  DECK_BUILDER_CHOOSE_UNIT_SLOT: 'DECK_BUILDER_CHOOSE_UNIT_SLOT',
  DECK_BUILDER_CHOOSE_HERO: 'DECK_BUILDER_CHOOSE_HERO',
  DECK_BUILDER_ERROR_NAME: 'DECK_BUILDER_ERROR_NAME',
  DECK_BUILDER_ERROR_HERO: 'DECK_BUILDER_ERROR_HERO',
  DECK_BUILDER_ERROR_TOWERS: 'DECK_BUILDER_ERROR_TOWERS',

  // Matchmaking
  MATCHMAKING_TITLE: 'MATCHMAKING_TITLE',
  MATCHMAKING_SEARCHING: 'MATCHMAKING_SEARCHING',
  MATCHMAKING_FOUND: 'MATCHMAKING_FOUND',
  MATCHMAKING_ERROR: 'MATCHMAKING_ERROR',
  MATCHMAKING_VS_BOT: 'MATCHMAKING_VS_BOT',
  MATCHMAKING_RETRY: 'MATCHMAKING_RETRY',
  MATCHMAKING_CANCEL: 'MATCHMAKING_CANCEL',
  MATCHMAKING_RANK_LABEL: 'MATCHMAKING_RANK_LABEL',
  MATCHMAKING_QUEUE_POSITION: 'MATCHMAKING_QUEUE_POSITION',
  MATCHMAKING_RELAXING: 'MATCHMAKING_RELAXING',
  MATCHMAKING_SERVER_OFFLINE: 'MATCHMAKING_SERVER_OFFLINE',
  MATCHMAKING_SERVER_OFFLINE_DESC: 'MATCHMAKING_SERVER_OFFLINE_DESC',
  MATCHMAKING_FALLBACK_TITLE: 'MATCHMAKING_FALLBACK_TITLE',
  MATCHMAKING_FALLBACK_DESC: 'MATCHMAKING_FALLBACK_DESC',
  MATCHMAKING_FALLBACK_STARTING: 'MATCHMAKING_FALLBACK_STARTING',
  MATCHMAKING_OPPONENT_RANK: 'MATCHMAKING_OPPONENT_RANK',

  // PackOpenAnimation
  PACK_OPEN_TITLE: 'PACK_OPEN_TITLE',
  PACK_OPEN_CLOSE: 'PACK_OPEN_CLOSE',
  PACK_OPEN_NEW: 'PACK_OPEN_NEW',

  // DailyPackButton
  DAILY_PACK_CLAIM: 'DAILY_PACK_CLAIM',
  DAILY_PACK_TOMORROW: 'DAILY_PACK_TOMORROW',

  // Hero spell tooltip
  HUD_SPELL_COOLDOWN_LABEL: 'HUD_SPELL_COOLDOWN_LABEL',
  HUD_SPELL_COOLDOWN_REMAINING: 'HUD_SPELL_COOLDOWN_REMAINING',
  HUD_SPELL_READY_Q: 'HUD_SPELL_READY_Q',

  // Tower tooltip
  HUD_TOOLTIP_SPLASH: 'HUD_TOOLTIP_SPLASH',
  HUD_TOOLTIP_RANGE_CELLS: 'HUD_TOOLTIP_RANGE_CELLS',

  // Settings — account, social, payment
  // Daily Login Streak
  STREAK_TITLE: 'STREAK_TITLE',
  STREAK_BROKEN: 'STREAK_BROKEN',
  STREAK_DAY: 'STREAK_DAY',
  STREAK_CLAIM: 'STREAK_CLAIM',
  STREAK_JACKPOT: 'STREAK_JACKPOT',
  STREAK_DAYS_LABEL: 'STREAK_DAYS_LABEL',

  SETTINGS_ACCOUNT: 'SETTINGS_ACCOUNT',
  SETTINGS_USERNAME: 'SETTINGS_USERNAME',
  SETTINGS_EMAIL: 'SETTINGS_EMAIL',
  SETTINGS_PASSWORD: 'SETTINGS_PASSWORD',
  SETTINGS_CHANGE_PASSWORD: 'SETTINGS_CHANGE_PASSWORD',
  SETTINGS_SERVER: 'SETTINGS_SERVER',
  SETTINGS_SOCIAL: 'SETTINGS_SOCIAL',
  SETTINGS_SOCIAL_CONNECT: 'SETTINGS_SOCIAL_CONNECT',
  SETTINGS_SOCIAL_CONNECTED: 'SETTINGS_SOCIAL_CONNECTED',
  SETTINGS_SOCIAL_DISCONNECT: 'SETTINGS_SOCIAL_DISCONNECT',
  SETTINGS_PAYMENT: 'SETTINGS_PAYMENT',
  SETTINGS_PAYMENT_ADD: 'SETTINGS_PAYMENT_ADD',
  SETTINGS_PAYMENT_CONNECTED: 'SETTINGS_PAYMENT_CONNECTED',
  SETTINGS_PAYMENT_REMOVE: 'SETTINGS_PAYMENT_REMOVE',
  SETTINGS_CURRENT_PASSWORD: 'SETTINGS_CURRENT_PASSWORD',
  SETTINGS_SAVE: 'SETTINGS_SAVE',
  SETTINGS_SAVING: 'SETTINGS_SAVING',
  SETTINGS_SAVED: 'SETTINGS_SAVED',
  SETTINGS_SAVE_ERROR: 'SETTINGS_SAVE_ERROR',
  SETTINGS_GUEST_NOTE: 'SETTINGS_GUEST_NOTE',

  // Tutorial
  TUTORIAL_STEP_1_TITLE: 'TUTORIAL_STEP_1_TITLE',
  TUTORIAL_STEP_1_DESC: 'TUTORIAL_STEP_1_DESC',
  TUTORIAL_STEP_2_TITLE: 'TUTORIAL_STEP_2_TITLE',
  TUTORIAL_STEP_2_DESC: 'TUTORIAL_STEP_2_DESC',
  TUTORIAL_STEP_3_TITLE: 'TUTORIAL_STEP_3_TITLE',
  TUTORIAL_STEP_3_DESC: 'TUTORIAL_STEP_3_DESC',
  TUTORIAL_STEP_4_TITLE: 'TUTORIAL_STEP_4_TITLE',
  TUTORIAL_STEP_4_DESC: 'TUTORIAL_STEP_4_DESC',
  TUTORIAL_STEP_5_TITLE: 'TUTORIAL_STEP_5_TITLE',
  TUTORIAL_STEP_5_DESC: 'TUTORIAL_STEP_5_DESC',
  TUTORIAL_NEXT: 'TUTORIAL_NEXT',
  TUTORIAL_SKIP: 'TUTORIAL_SKIP',
  TUTORIAL_COMPLETE: 'TUTORIAL_COMPLETE',
  TUTORIAL_REWARD_TITLE: 'TUTORIAL_REWARD_TITLE',
  TUTORIAL_REWARD_XP: 'TUTORIAL_REWARD_XP',
  TUTORIAL_REWARD_GOLD: 'TUTORIAL_REWARD_GOLD',
  TUTORIAL_REWARD_PACK: 'TUTORIAL_REWARD_PACK',
  TUTORIAL_ACHIEVEMENT_UNLOCKED: 'TUTORIAL_ACHIEVEMENT_UNLOCKED',
  TUTORIAL_STEP_4_ELEMENT_CYCLE: 'TUTORIAL_STEP_4_ELEMENT_CYCLE',
  TUTORIAL_STEP_4_AXIS: 'TUTORIAL_STEP_4_AXIS',

  // ErrorBoundary
  ERROR_BOUNDARY_HEADING: 'ERROR_BOUNDARY_HEADING',
  ERROR_BOUNDARY_RELOAD: 'ERROR_BOUNDARY_RELOAD',

  // Quest titles — values stored directly in questDefinitions.ts as i18n keys
  QUEST_SEND_UNITS_10: 'QUEST_SEND_UNITS_10',
  QUEST_WIN_MATCH: 'QUEST_WIN_MATCH',
  QUEST_BUILD_20_TOWERS: 'QUEST_BUILD_20_TOWERS',
  QUEST_WIN_5_PVP: 'QUEST_WIN_5_PVP',
  QUEST_COMPLETE_TUTORIAL: 'QUEST_COMPLETE_TUTORIAL',
  QUEST_BUG_TRACKER_BRONZE: 'QUEST_BUG_TRACKER_BRONZE',
  QUEST_BUG_TRACKER_SILBER: 'QUEST_BUG_TRACKER_SILBER',
  QUEST_BUG_TRACKER_GOLD: 'QUEST_BUG_TRACKER_GOLD',
  QUEST_BUG_TRACKER_PLATIN: 'QUEST_BUG_TRACKER_PLATIN',
  QUEST_BUG_TRACKER_DIAMANT: 'QUEST_BUG_TRACKER_DIAMANT',
  // Quest descriptions (used in BootScene QuestSystem init)
  QUEST_SEND_UNITS_10_DESC: 'QUEST_SEND_UNITS_10_DESC',
  QUEST_WIN_MATCH_DESC: 'QUEST_WIN_MATCH_DESC',
  QUEST_BUILD_20_TOWERS_DESC: 'QUEST_BUILD_20_TOWERS_DESC',
  QUEST_WIN_5_PVP_DESC: 'QUEST_WIN_5_PVP_DESC',
  // BootScene loading bar messages
  BOOT_LOADING_GAMEDATA: 'BOOT_LOADING_GAMEDATA',
  BOOT_LOADING_READY: 'BOOT_LOADING_READY',

  // Bot opponent display names (array key — use i18n.t('BOT_NAMES', { returnObjects: true }))
  BOT_NAMES: 'BOT_NAMES',

  // Matchmaking — anonymous player name prefix before auth (Phase 5 replaces this)
  MATCHMAKING_ANON_PREFIX: 'MATCHMAKING_ANON_PREFIX',

  // Element names (used in DeckBuilder filter buttons and tooltips)
  ELEMENT_NAME_FIRE: 'ELEMENT_NAME_FIRE',
  ELEMENT_NAME_WATER: 'ELEMENT_NAME_WATER',
  ELEMENT_NAME_NATURE: 'ELEMENT_NAME_NATURE',
  ELEMENT_NAME_ELEKTRO: 'ELEMENT_NAME_ELEKTRO',
  ELEMENT_NAME_LIGHT: 'ELEMENT_NAME_LIGHT',
  ELEMENT_NAME_SHADOW: 'ELEMENT_NAME_SHADOW',
  ELEMENT_NAME_NEUTRAL: 'ELEMENT_NAME_NEUTRAL',

  // MapSelect synergy badge
  MAP_SELECT_SYNERGY: 'MAP_SELECT_SYNERGY',

  // OfflineBanner
  OFFLINE_BANNER_TEXT: 'OFFLINE_BANNER_TEXT',

  // PushPermissionModal
  PUSH_MODAL_TITLE: 'PUSH_MODAL_TITLE',
  PUSH_MODAL_BODY: 'PUSH_MODAL_BODY',
  PUSH_MODAL_BULLET_PACK: 'PUSH_MODAL_BULLET_PACK',
  PUSH_MODAL_BULLET_PVP: 'PUSH_MODAL_BULLET_PVP',
  PUSH_MODAL_ACCEPT: 'PUSH_MODAL_ACCEPT',
  PUSH_MODAL_SETTING_UP: 'PUSH_MODAL_SETTING_UP',
  PUSH_MODAL_DECLINE: 'PUSH_MODAL_DECLINE',

  // Settings — notes (shown below social/payment sections)
  SETTINGS_SOCIAL_SHARING_NOTE: 'SETTINGS_SOCIAL_SHARING_NOTE',
  SETTINGS_PAYMENT_NOTE: 'SETTINGS_PAYMENT_NOTE',

  // Feedback / Bug Report screen
  FEEDBACK_TITLE: 'FEEDBACK_TITLE',
  FEEDBACK_BACK: 'FEEDBACK_BACK',
  FEEDBACK_TYPE_LABEL: 'FEEDBACK_TYPE_LABEL',
  FEEDBACK_TYPE_BUG: 'FEEDBACK_TYPE_BUG',
  FEEDBACK_TYPE_IDEA: 'FEEDBACK_TYPE_IDEA',
  FEEDBACK_TYPE_OTHER: 'FEEDBACK_TYPE_OTHER',
  FEEDBACK_TITLE_LABEL: 'FEEDBACK_TITLE_LABEL',
  FEEDBACK_TITLE_PLACEHOLDER: 'FEEDBACK_TITLE_PLACEHOLDER',
  FEEDBACK_DESC_LABEL: 'FEEDBACK_DESC_LABEL',
  FEEDBACK_DESC_PLACEHOLDER: 'FEEDBACK_DESC_PLACEHOLDER',
  FEEDBACK_SUBMIT: 'FEEDBACK_SUBMIT',
  FEEDBACK_SUBMITTING: 'FEEDBACK_SUBMITTING',
  FEEDBACK_SUCCESS_TITLE: 'FEEDBACK_SUCCESS_TITLE',
  FEEDBACK_SUCCESS_DESC: 'FEEDBACK_SUCCESS_DESC',
  FEEDBACK_SUCCESS_ID: 'FEEDBACK_SUCCESS_ID',
  FEEDBACK_ERROR: 'FEEDBACK_ERROR',
  FEEDBACK_VALIDATION_REQUIRED: 'FEEDBACK_VALIDATION_REQUIRED',
  FEEDBACK_MY_REPORTS_TITLE: 'FEEDBACK_MY_REPORTS_TITLE',
  FEEDBACK_STATUS_NEW: 'FEEDBACK_STATUS_NEW',
  FEEDBACK_STATUS_REVIEWING: 'FEEDBACK_STATUS_REVIEWING',
  FEEDBACK_STATUS_CONFIRMED: 'FEEDBACK_STATUS_CONFIRMED',
  FEEDBACK_STATUS_RESOLVED: 'FEEDBACK_STATUS_RESOLVED',
  FEEDBACK_STATUS_REJECTED: 'FEEDBACK_STATUS_REJECTED',
  FEEDBACK_ACHIEVEMENT_HINT: 'FEEDBACK_ACHIEVEMENT_HINT',
  FEEDBACK_BTN_REPORT: 'FEEDBACK_BTN_REPORT',

  // Toast messages
  TOAST_QUEST_COMPLETED: 'TOAST_QUEST_COMPLETED',
  TOAST_ACHIEVEMENT_UNLOCKED: 'TOAST_ACHIEVEMENT_UNLOCKED',
  TOAST_MATCH_WIN: 'TOAST_MATCH_WIN',
  TOAST_REWARD_CLAIMED: 'TOAST_REWARD_CLAIMED',
  TOAST_TUTORIAL_REWARD: 'TOAST_TUTORIAL_REWARD',

  // ChallengeModal
  CHALLENGE_MODAL_TITLE: 'CHALLENGE_MODAL_TITLE',
  CHALLENGE_MODAL_FROM: 'CHALLENGE_MODAL_FROM',
  CHALLENGE_MODAL_ACCEPT: 'CHALLENGE_MODAL_ACCEPT',
  CHALLENGE_MODAL_DECLINE: 'CHALLENGE_MODAL_DECLINE',
  CHALLENGE_MODAL_EXPIRES: 'CHALLENGE_MODAL_EXPIRES',

  // Auth — Google OAuth
  LOGIN_OR: 'LOGIN_OR',
  LOGIN_GOOGLE: 'LOGIN_GOOGLE',

  // Tutorial — Deck picker (Step 6)
  TUTORIAL_DECK_TITLE: 'TUTORIAL_DECK_TITLE',
  TUTORIAL_DECK_DESC: 'TUTORIAL_DECK_DESC',
  TUTORIAL_DECK_CONFIRM: 'TUTORIAL_DECK_CONFIRM',
  TUTORIAL_DECK_NAME: 'TUTORIAL_DECK_NAME',

  // Mode select screen (1v1 / 2v2 / 3v3)
  MODE_SELECT_TITLE: 'MODE_SELECT_TITLE',
  MODE_SELECT_SUB: 'MODE_SELECT_SUB',
  MODE_1V1_TITLE: 'MODE_1V1_TITLE',
  MODE_1V1_DESC: 'MODE_1V1_DESC',
  MODE_2V2_TITLE: 'MODE_2V2_TITLE',
  MODE_2V2_DESC: 'MODE_2V2_DESC',
  MODE_3V3_TITLE: 'MODE_3V3_TITLE',
  MODE_3V3_DESC: 'MODE_3V3_DESC',

  // Campaign
  CAMPAIGN_TITLE: 'CAMPAIGN_TITLE',
  CAMPAIGN_SUBTITLE: 'CAMPAIGN_SUBTITLE',
  CAMPAIGN_MISSION_N: 'CAMPAIGN_MISSION_N',
  CAMPAIGN_OBJECTIVE: 'CAMPAIGN_OBJECTIVE',
  CAMPAIGN_HINT: 'CAMPAIGN_HINT',
  CAMPAIGN_COMPLETE_TOAST: 'CAMPAIGN_COMPLETE_TOAST',
  CAMPAIGN_FAIL_TOAST: 'CAMPAIGN_FAIL_TOAST',

  // Campaign mission titles
  CAMPAIGN_M1_TITLE: 'CAMPAIGN_M1_TITLE',
  CAMPAIGN_M2_TITLE: 'CAMPAIGN_M2_TITLE',
  CAMPAIGN_M3_TITLE: 'CAMPAIGN_M3_TITLE',
  CAMPAIGN_M4_TITLE: 'CAMPAIGN_M4_TITLE',
  CAMPAIGN_M5_TITLE: 'CAMPAIGN_M5_TITLE',

  // Campaign mission descriptions
  CAMPAIGN_M1_DESC: 'CAMPAIGN_M1_DESC',
  CAMPAIGN_M2_DESC: 'CAMPAIGN_M2_DESC',
  CAMPAIGN_M3_DESC: 'CAMPAIGN_M3_DESC',
  CAMPAIGN_M4_DESC: 'CAMPAIGN_M4_DESC',
  CAMPAIGN_M5_DESC: 'CAMPAIGN_M5_DESC',

  // Campaign mission objectives (shown as "Ziel: ...")
  CAMPAIGN_M1_OBJ: 'CAMPAIGN_M1_OBJ',
  CAMPAIGN_M2_OBJ: 'CAMPAIGN_M2_OBJ',
  CAMPAIGN_M3_OBJ: 'CAMPAIGN_M3_OBJ',
  CAMPAIGN_M4_OBJ: 'CAMPAIGN_M4_OBJ',
  CAMPAIGN_M5_OBJ: 'CAMPAIGN_M5_OBJ',

  // Main Menu campaign button
  MAIN_MENU_CAMPAIGN: 'MAIN_MENU_CAMPAIGN',

  // Main Menu coop button
  MAIN_MENU_COOP: 'MAIN_MENU_COOP',

  // Coop matchmaking screen
  COOP_MATCHMAKING_TITLE: 'COOP_MATCHMAKING_TITLE',
  COOP_MATCHMAKING_SEARCHING: 'COOP_MATCHMAKING_SEARCHING',
  COOP_MATCHMAKING_FOUND: 'COOP_MATCHMAKING_FOUND',
  COOP_MATCHMAKING_PARTNER: 'COOP_MATCHMAKING_PARTNER',
  COOP_MATCHMAKING_STARTING: 'COOP_MATCHMAKING_STARTING',
  COOP_MATCHMAKING_FALLBACK: 'COOP_MATCHMAKING_FALLBACK',
  COOP_MATCHMAKING_FALLBACK_DESC: 'COOP_MATCHMAKING_FALLBACK_DESC',
  COOP_MATCHMAKING_CANCEL: 'COOP_MATCHMAKING_CANCEL',
  COOP_MATCHMAKING_OFFLINE: 'COOP_MATCHMAKING_OFFLINE',
  COOP_MATCHMAKING_OFFLINE_DESC: 'COOP_MATCHMAKING_OFFLINE_DESC',
  HUD_COOP_PARTNER_HP: 'HUD_COOP_PARTNER_HP',
  HUD_COOP_PARTNER_DEFEATED: 'HUD_COOP_PARTNER_DEFEATED',

  // Season Pass
  SEASON_DAYS_LEFT: 'SEASON_DAYS_LEFT',
  SEASON_LEVEL_LABEL: 'SEASON_LEVEL_LABEL',
  SEASON_PREMIUM_DESC: 'SEASON_PREMIUM_DESC',
  SEASON_BUY_PASS: 'SEASON_BUY_PASS',
  SEASON_PREMIUM_ACTIVE: 'SEASON_PREMIUM_ACTIVE',
  SEASON_PASS_OWNED: 'SEASON_PASS_OWNED',
  SEASON_TRACK_FREE: 'SEASON_TRACK_FREE',
  SEASON_TRACK_PREMIUM: 'SEASON_TRACK_PREMIUM',
  SEASON_CLAIM: 'SEASON_CLAIM',
  SEASON_CLAIMED: 'SEASON_CLAIMED',
  SEASON_LOCKED: 'SEASON_LOCKED',
  SEASON_PREMIUM_ONLY: 'SEASON_PREMIUM_ONLY',
  SEASON_CLAIMED_COUNT: 'SEASON_CLAIMED_COUNT',
  SEASON_XP_LABEL: 'SEASON_XP_LABEL',

  // CardDetailScreen
  CARD_DETAIL_BACK: 'CARD_DETAIL_BACK',
  CARD_DETAIL_NOT_FOUND: 'CARD_DETAIL_NOT_FOUND',
  CARD_DETAIL_LEVEL: 'CARD_DETAIL_LEVEL',
  CARD_DETAIL_COPIES_TO_NEXT: 'CARD_DETAIL_COPIES_TO_NEXT',
  CARD_DETAIL_MAX_LEVEL: 'CARD_DETAIL_MAX_LEVEL',
  CARD_DETAIL_LEVEL_BONUSES: 'CARD_DETAIL_LEVEL_BONUSES',
  CARD_DETAIL_STATS: 'CARD_DETAIL_STATS',
  CARD_DETAIL_STATS_BASE: 'CARD_DETAIL_STATS_BASE',
  CARD_DETAIL_STATS_CURRENT: 'CARD_DETAIL_STATS_CURRENT',
  CARD_DETAIL_SKILL_TREE: 'CARD_DETAIL_SKILL_TREE',
  CARD_DETAIL_GATE_LEVEL: 'CARD_DETAIL_GATE_LEVEL',
  CARD_DETAIL_GATE_LOCKED: 'CARD_DETAIL_GATE_LOCKED',
  CARD_DETAIL_GATE_CHOOSE: 'CARD_DETAIL_GATE_CHOOSE',
  CARD_DETAIL_GATE_DONE: 'CARD_DETAIL_GATE_DONE',
  CARD_DETAIL_CHOOSE: 'CARD_DETAIL_CHOOSE',
  CARD_DETAIL_NODE_REQUIRES: 'CARD_DETAIL_NODE_REQUIRES',
  CARD_DETAIL_RESET: 'CARD_DETAIL_RESET',
  CARD_DETAIL_RESET_NO_GEMS: 'CARD_DETAIL_RESET_NO_GEMS',
  CARD_DETAIL_CAT_TOWER: 'CARD_DETAIL_CAT_TOWER',
  CARD_DETAIL_CAT_UNIT: 'CARD_DETAIL_CAT_UNIT',
  CARD_DETAIL_CAT_HERO: 'CARD_DETAIL_CAT_HERO',
  CARD_DETAIL_STAT_DMG: 'CARD_DETAIL_STAT_DMG',
  CARD_DETAIL_STAT_SPD: 'CARD_DETAIL_STAT_SPD',
  CARD_DETAIL_STAT_RANGE: 'CARD_DETAIL_STAT_RANGE',
  CARD_DETAIL_STAT_CRIT: 'CARD_DETAIL_STAT_CRIT',
  CARD_DETAIL_STAT_SPLASH: 'CARD_DETAIL_STAT_SPLASH',
  CARD_DETAIL_STAT_SLOW: 'CARD_DETAIL_STAT_SLOW',
  CARD_DETAIL_STAT_CHAIN: 'CARD_DETAIL_STAT_CHAIN',
  CARD_DETAIL_STAT_INCOME: 'CARD_DETAIL_STAT_INCOME',
  CARD_DETAIL_STAT_ARMOR: 'CARD_DETAIL_STAT_ARMOR',
  CARD_DETAIL_STAT_DODGE: 'CARD_DETAIL_STAT_DODGE',
  CARD_DETAIL_STAT_PASSIVE: 'CARD_DETAIL_STAT_PASSIVE',
  CARD_DETAIL_STAT_COOLDOWN: 'CARD_DETAIL_STAT_COOLDOWN',

  // FriendsScreen
  FRIENDS_TITLE: 'FRIENDS_TITLE',
  FRIENDS_TAB_FRIENDS: 'FRIENDS_TAB_FRIENDS',
  FRIENDS_ADD_PLACEHOLDER: 'FRIENDS_ADD_PLACEHOLDER',
  FRIENDS_SEND_REQUEST: 'FRIENDS_SEND_REQUEST',
  FRIENDS_REMOVE: 'FRIENDS_REMOVE',

  // ReplayScreen
  REPLAY_TITLE: 'REPLAY_TITLE',
  REPLAY_EMPTY: 'REPLAY_EMPTY',
  REPLAY_OUTCOME_WIN: 'REPLAY_OUTCOME_WIN',
  REPLAY_OUTCOME_LOSS: 'REPLAY_OUTCOME_LOSS',
  REPLAY_OUTCOME_DRAW: 'REPLAY_OUTCOME_DRAW',
  REPLAY_VIEW_BUTTON: 'REPLAY_VIEW_BUTTON',
  REPLAY_NO_DATA: 'REPLAY_NO_DATA',
  REPLAY_TIMELINE_TITLE: 'REPLAY_TIMELINE_TITLE',
  REPLAY_HP_CHART_LABEL: 'REPLAY_HP_CHART_LABEL',
  REPLAY_GOLD_CHART_LABEL: 'REPLAY_GOLD_CHART_LABEL',
  REPLAY_EVENTS_LABEL: 'REPLAY_EVENTS_LABEL',
  REPLAY_CLOSE: 'REPLAY_CLOSE',
  REPLAY_PLAY: 'REPLAY_PLAY',
  REPLAY_PAUSE: 'REPLAY_PAUSE',
  REPLAY_MY_HP: 'REPLAY_MY_HP',
  REPLAY_OPP_HP: 'REPLAY_OPP_HP',
  REPLAY_HP_CHART: 'REPLAY_HP_CHART',
  REPLAY_KEY_EVENTS: 'REPLAY_KEY_EVENTS',
  REPLAY_VIEW_BTN: 'REPLAY_VIEW_BTN',

  // ProfileScreen
  PROFILE_TITLE: 'PROFILE_TITLE',
  PROFILE_STATS: 'PROFILE_STATS',
  PROFILE_AVATAR: 'PROFILE_AVATAR',
  PROFILE_BIO: 'PROFILE_BIO',
  PROFILE_SAVE: 'PROFILE_SAVE',
  PROFILE_SAVED: 'PROFILE_SAVED',
  PROFILE_WINRATE: 'PROFILE_WINRATE',

  // Spectator Mode
  SPECTATOR_TITLE:   'SPECTATOR_TITLE',
  SPECTATOR_LIVE:    'SPECTATOR_LIVE',
  SPECTATOR_EMPTY:   'SPECTATOR_EMPTY',
  SPECTATOR_WATCH:   'SPECTATOR_WATCH',
  SPECTATOR_LEAVE:   'SPECTATOR_LEAVE',
  SPECTATOR_PLAYER1: 'SPECTATOR_PLAYER1',
  SPECTATOR_PLAYER2: 'SPECTATOR_PLAYER2',

  // Tournament
  TOURNAMENT_TITLE:          'TOURNAMENT_TITLE',
  TOURNAMENT_JOIN:           'TOURNAMENT_JOIN',
  TOURNAMENT_JOINED:         'TOURNAMENT_JOINED',
  TOURNAMENT_FULL:           'TOURNAMENT_FULL',
  TOURNAMENT_BRACKET:        'TOURNAMENT_BRACKET',
  TOURNAMENT_MY:             'TOURNAMENT_MY',
  TOURNAMENT_EMPTY:          'TOURNAMENT_EMPTY',
  TOURNAMENT_STATUS_OPEN:    'TOURNAMENT_STATUS_OPEN',
  TOURNAMENT_STATUS_RUNNING: 'TOURNAMENT_STATUS_RUNNING',
  TOURNAMENT_CHAMPION:       'TOURNAMENT_CHAMPION',

  // Season End
  SEASON_ENDS_IN: 'SEASON_ENDS_IN',
  SEASON_ENDED: 'SEASON_ENDED',
  SEASON_CLAIM_REWARDS: 'SEASON_CLAIM_REWARDS',
  SEASON_REWARDS_CLAIMED: 'SEASON_REWARDS_CLAIMED',
  SEASON_NEXT: 'SEASON_NEXT',
  SEASON_TITLE_EARNED: 'SEASON_TITLE_EARNED',

  // Clans
  CLAN_TITLE:       'CLAN_TITLE',
  CLAN_MY:          'CLAN_MY',
  CLAN_SEARCH:      'CLAN_SEARCH',
  CLAN_CREATE:      'CLAN_CREATE',
  CLAN_LEADERBOARD: 'CLAN_LEADERBOARD',
  CLAN_JOIN:        'CLAN_JOIN',
  CLAN_LEAVE:       'CLAN_LEAVE',
  CLAN_NAME:        'CLAN_NAME',
  CLAN_TAG:         'CLAN_TAG',
  CLAN_DESC:        'CLAN_DESC',
  CLAN_FULL:        'CLAN_FULL',
  CLAN_EMPTY:       'CLAN_EMPTY',
  CLAN_CREATED:     'CLAN_CREATED',
  CLAN_JOINED:      'CLAN_JOINED',
  CLAN_LEFT:        'CLAN_LEFT',
  CLAN_OWNER:       'CLAN_OWNER',
  CLAN_MEMBER:      'CLAN_MEMBER',
  CLAN_OFFICER:     'CLAN_OFFICER',
  CLAN_NOT_IN_CLAN:        'CLAN_NOT_IN_CLAN',
  CLAN_TOTAL_ELO:          'CLAN_TOTAL_ELO',
  CLAN_SEARCH_PLACEHOLDER: 'CLAN_SEARCH_PLACEHOLDER',
  CLAN_TAG_HINT:           'CLAN_TAG_HINT',

  // HUD tooltip keys (used in Phaser scenes — kept in sync with JSON)
  HUD_TOOLTIP_DAMAGE:    'HUD_TOOLTIP_DAMAGE',
  HUD_TOOLTIP_SPEED:     'HUD_TOOLTIP_SPEED',
  HUD_TOOLTIP_RANGE:     'HUD_TOOLTIP_RANGE',
  HUD_TOOLTIP_CRIT:      'HUD_TOOLTIP_CRIT',
  HUD_TOOLTIP_SLOW:      'HUD_TOOLTIP_SLOW',
  HUD_TOOLTIP_CHAIN:     'HUD_TOOLTIP_CHAIN',
  HUD_TOOLTIP_INCOME:    'HUD_TOOLTIP_INCOME',
  HUD_TOOLTIP_ARMOR:     'HUD_TOOLTIP_ARMOR',
  HUD_TOOLTIP_DODGE:     'HUD_TOOLTIP_DODGE',
  HUD_TOOLTIP_KILL_REWARD: 'HUD_TOOLTIP_KILL_REWARD',
  HUD_QUEST_CLAIMED:     'HUD_QUEST_CLAIMED',
  HUD_SOUND_OFF:         'HUD_SOUND_OFF',
  HUD_SOUND_ON:          'HUD_SOUND_ON',
  HUD_ROTATE_VIEW:       'HUD_ROTATE_VIEW',
  HUD_BUILD:             'HUD_BUILD',
  HUD_SEND_UNIT:         'HUD_SEND_UNIT',
  HUD_SPY_ENEMY:         'HUD_SPY_ENEMY',
  HUD_CANCEL_PLACEMENT:  'HUD_CANCEL_PLACEMENT',
  HUD_BASE_MAX:          'HUD_BASE_MAX',

  // Rarity labels
  RARITY_COMMON:    'RARITY_COMMON',
  RARITY_RARE:      'RARITY_RARE',
  RARITY_EPIC:      'RARITY_EPIC',
  RARITY_LEGENDARY: 'RARITY_LEGENDARY',

  // Phaser scene strings
  PHASER_GOLD_UNIT:       'PHASER_GOLD_UNIT',
  PHASER_PACK_TAP_HINT:   'PHASER_PACK_TAP_HINT',
  PHASER_PACK_REVEAL_ALL: 'PHASER_PACK_REVEAL_ALL',
  PHASER_PACK_CLOSE:      'PHASER_PACK_CLOSE',
  PHASER_PACK_NEW_BADGE:  'PHASER_PACK_NEW_BADGE',

  // Spectator back button
  SPECTATOR_BACK: 'SPECTATOR_BACK',
} as const

export type StringKey = keyof typeof S
// Convenience type alias – use with t() calls: const { t } = useTranslation(); t(S.KEY)
export type I18nKey = keyof typeof S
